import { motion } from "framer-motion";

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <span className="font-heading text-2xl md:text-[1.75rem] leading-none tracking-tight text-white">
      U<span className="text-gold">C</span>C
    </span>
    <span className="hidden sm:block h-6 w-px bg-white/20" />
    <span className="hidden sm:block text-[0.6rem] uppercase tracking-[0.35em] text-white/60 leading-tight">
      Upper Class
      <br />
      Chauffeurs
    </span>
  </div>
);

export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 text-[0.7rem] uppercase tracking-[0.35em] text-gold ${className}`}
  >
    <span className="h-px w-8 bg-gold/60" />
    {children}
  </span>
);

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
